"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRecentGames = void 0;
var keys_1 = require("../keys");
var react_1 = require("react");
var useQuery_1 = require("../useQuery");
var user_1 = require("../user");
var game_api_1 = require("@l2p/game-api");
var apps_shared_1 = require("@l2p/apps-shared");
var geo_1 = require("../geo");
var currencies_1 = require("../currencies");
var useCache_1 = require("../useCache");
var CURRENT_CURRENCY = 'current_currency';
var useRecentGames = function () {
    var _a, _b;
    var isAuth = (0, user_1.useIsAuthorized)();
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var geoData = (0, geo_1.useGeo)().data;
    var currentCurrency = (0, currencies_1.useCurrentCurrency)();
    var _c = (0, useCache_1.useCache)(), getDataFromCache = _c.getDataFromCache, setDataToCache = _c.setDataToCache;
    var isReady = (0, react_1.useMemo)(function () { return !!(Object.keys(breakpoints).length > 0 && geoData && currentCurrency); }, [breakpoints, geoData, currentCurrency]);
    var _d = (0, useQuery_1.useQuery)({
        canRender: isAuth && isReady,
        path: keys_1.GET_RECENT_GAMES,
        revalidateOnMount: true,
        payload: {
            devices: [
                breakpoints.mobile || breakpoints.tablet
                    ? game_api_1.GameDeviceTypeEnum.Mobile
                    : game_api_1.GameDeviceTypeEnum.Desktop,
                game_api_1.GameDeviceTypeEnum.Universal,
            ],
            allowedCountries: ((_a = geoData === null || geoData === void 0 ? void 0 : geoData.geoData) === null || _a === void 0 ? void 0 : _a.countryCode)
                ? [(_b = geoData === null || geoData === void 0 ? void 0 : geoData.geoData) === null || _b === void 0 ? void 0 : _b.countryCode]
                : undefined,
            currencies: currentCurrency ? [currentCurrency] : undefined,
        },
    }), data = _d.data, error = _d.error, isLoading = _d.isLoading, mutate = _d.mutate;
    (0, react_1.useEffect)(function () {
        var prevCurrency = getDataFromCache(CURRENT_CURRENCY);
        if (!prevCurrency || prevCurrency !== currentCurrency) {
            mutate();
            setDataToCache(CURRENT_CURRENCY, currentCurrency);
        }
    }, [getDataFromCache, setDataToCache, currentCurrency, mutate]);
    return (0, react_1.useMemo)(function () { return ({
        data: data === null || data === void 0 ? void 0 : data.data,
        isLoading: isLoading,
        error: error,
    }); }, [data, isLoading, error]);
};
exports.useRecentGames = useRecentGames;
